module.exports = __webpack_public_path__ + "img/12_jbt8010_1-1999.prt.739be712.jpg";